import React, { Component } from 'react';
import '../css/App.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import IdleTimerLogout from './IdleTimerLogout';
class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

        };
    }
    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/');
        }
        this.setState({ data: this.props.location.state })
        console.log(this.props.location.state)
    }
    _start(len) {
        if(len>0){
        this.props.history.push('/units/' +this.props.location.state.data.program_id,{checklist:false})
        }
        else{
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className='row'>
                            <div className="col-12" style={{ width: 300, background: '#fff', padding: 20, boxShadow: '0px 0px 12px 3px #dbdbdb' }}>
                                <h3 className="">Koach</h3>
                                <p>Oops! There is no content here yet.</p>
                                <div className="flex justify-content-end">
                                    <span style={{ color: '#005284', fontSize: 14 }} onClick={() => { this.props.history.push('/dashboard'); onClose(); }} > OK </span>
                                </div>
                            </div>
                        </div>
                    );
                }
            });
        }
    }
    render() {
        const len =this.state.data.data.microstep_titles.length;
        const datalength = (100 / this.state.data.data.microstep_titles.length);
        console.log(len)
        return (

            <div className="">
              
                <nav class="navbar navbar-top navbar-expand navbar-dark  border-bottom">
                    <div class="container pad_z">
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="col-sm-3 pad_z ">
                                <i className="material-icons back-btn grey-text" onClick={() => this.props.history.goBack()}>arrow_back</i>
                            </div>
                            <div className="col-sm-6 text-center pad_z" style={{fontSize:20}}> OverView</div>
                            <div className="col-sm-3 text-right  pad_z vertical-align justify-content-end"></div>

                        </div>
                    </div>
                </nav>

                <div className="container">

                    <div className="row marRight-5 marLeft-5">
                        <div className="col-sm-12 pad_z">
                            <div className="card az-color text-white">
                                <h4 className="text-white">{this.state.data.data.program_title}</h4>
                                {/* <p>{this.state.data.data.description}</p> */}
                                <div dangerouslySetInnerHTML={{__html: this.state.data.data.description}}/>
                                <div className="col-12 steps pad_z" >
                                    {this.state.data.data.microstep_titles.map((item, i) => {
                                        return (
                                            <span key={i} className="step" style={{ width: datalength + '%' }}></span>
                                        )
                                    })}
                                </div>                </div>

                        </div>
                        <div className="col-12 step-btn justify-content-center">
                            <button

                                type="button" style={{width:'100px',justifyContent:'center'}} onClick={() => this._start(len)}>
                                Start

                            </button>
                        </div>
                    </div>
                    </div>
                    </div>
        )
    }
}
export default Overview;